module.exports = __webpack_public_path__ + "img/jewellery@2x.42937af.webp";